import { catchError, switchMap, tap } from 'rxjs/operators';
import { closeLocationSelector } from '../../utils/location';
import { dispatch } from '../store';
import { Epic, ofType } from 'redux-observable';
import { getNearestBranch } from '../../apis/equipment';
import { LocationStatus } from '../../types/location';
import { of } from 'rxjs';
import {
  LocationState,
  SetUserLocationPayload,
  selectLocationFulfilled,
  selectLocationRejected,
  setLocationStatus,
  setUserLocationEpicAction,
} from '../slice/locationSlice';

const setUserLocationEpic: Epic = (action$) =>
  action$.pipe(
    ofType(setUserLocationEpicAction),
    tap(() => {
      dispatch(
        setLocationStatus({
          status: LocationStatus.IS_LOADING,
        }),
      );
    }),
    switchMap(async (action) => {
      try {
        const payload: SetUserLocationPayload = action.payload;
        const selectedLocation = payload.userLocation;
        const response = await getNearestBranch(
          selectedLocation.latitude,
          selectedLocation.longitude,
        );
        const state: LocationState = {
          status: null,
          userLocation: selectedLocation,
          branch: response,
        };
        closeLocationSelector();
        return selectLocationFulfilled(state);
      } catch (error) {
        return selectLocationRejected();
      }
    }),
    catchError(() => of(selectLocationRejected())),
  );

export default setUserLocationEpic;
